import { useEffect, useState, VFC } from "react";
// Libraries
import { useHistory } from "react-router";
// Utils
import { CREATE_BATCH, CREATE_GROUP } from "constants/Routes";
import { ELEMENTS_IDS } from "constants/ElementsIds";
import { useGetGroups, useEventRequest, useStateSpecies, useLivestockTabs } from "hooks";
// Components
import { GroupItem } from "components/MyLivestock";
import {
  LoadingOverlay,
  Header,
  PageContent,
  PageHeader,
  Spacer,
  Tabs,
  Tiles,
  EmptyState,
  Modal,
  Button,
  KeyValuePair,
} from "components";
// Resources
import styles from "./Groups.module.scss";

const Groups: VFC = () => {
  const { active: speciesActive } = useStateSpecies();
  const LIVESTOCK_TABS = useLivestockTabs();
  const [showModal, setShowModal] = useState(false);
  const speciesActiveName = speciesActive?.name || "Livestock";
  const title = `My ${speciesActiveName}`;
  const subTitle = `View and manage your ${speciesActiveName.toLowerCase()}`;

  const history = useHistory();
  const { data: groups, loading } = useGetGroups();
  const { eventsRequest } = useEventRequest();

  const isEmptyStateVisible = !loading && !groups.length;
  useEffect(() => {
    eventsRequest({ name: "group-show" });
  }, []);

  return (
    <>
      {loading && groups.length === 0 && <LoadingOverlay customStyles={styles.loadingOverlay} />}
      <Modal active={showModal} title="Create a new:" handleClose={() => setShowModal(false)} showCloseButton>
        {
          <>
            <KeyValuePair
              label={`Group of Animals`}
              stacked
              value="Allows quick creation of animals, IDs can be added at a later date."
            />
            <Spacer baselineHeight={1} />
            <Button caption={`Create Group`} onClick={(): void => history.push(CREATE_BATCH)} />
            <Spacer baselineHeight={3} border="middle" />
          </>
        }
        <KeyValuePair
          label="Group of Individuals"
          stacked
          value="You can then add animals you already have on Breedr with IDs."
        />
        <Spacer baselineHeight={1} />
        <Button caption="Create Group" onClick={(): void => history.push(CREATE_GROUP)} />
      </Modal>
      <PageHeader>
        <Header title={title} subTitle={subTitle} />

        <Tabs tabs={LIVESTOCK_TABS} selectedTab={1} />
      </PageHeader>

      <PageContent
        floatingIconButton={{
          id: ELEMENTS_IDS.ADD_GROUP_PLUS_BUTTON,
          iconName: "plus",
          // onClick: (): void => history.push(CREATE_GROUP),
          onClick: (): void => setShowModal(true),
        }}
      >
        <Spacer baselineHeight={2} />

        {isEmptyStateVisible ? (
          <EmptyState page="GROUPS" />
        ) : (
          <Tiles size="large">
            {groups.map((group) => (
              <GroupItem group={group} key={group.id} />
            ))}
          </Tiles>
        )}
      </PageContent>
    </>
  );
};

export default Groups;
